class ToggleSwitch {
    /**
     * Creates a toggle switch instance
     * @param {HTMLElement} element - The button element with class "toggle-switch"
     */
    constructor(element) {
        if (!element) throw new Error('ToggleSwitch requires an element');

        this.button = element;
        this.hiddenInput = this.button.querySelector('input[type="hidden"]');
        this.init();
    }

    init() {
        // Initialize ARIA state if not set
        if (!this.button.hasAttribute('aria-pressed')) {
        const initial = this.hiddenInput?.value === '1';
        this.button.setAttribute('aria-pressed', initial);
        }

        // Click handler
        this.button.addEventListener('click', () => this.toggle());
    }

    toggle() {
        const isPressed = this.button.getAttribute('aria-pressed') === 'true';
        this.button.setAttribute('aria-pressed', !isPressed);
        if (this.hiddenInput) this.hiddenInput.value = !isPressed ? '1' : '0';
    }

    setState(state) {
        this.button.setAttribute('aria-pressed', !!state);
        if (this.hiddenInput) this.hiddenInput.value = state ? '1' : '0';
    }

    getState() {
        return this.button.getAttribute('aria-pressed') === 'true';
    }
}

// Export the class in case you want to manually instantiate
export default ToggleSwitch;